import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { toEnglishNum, toPersianNum, toPureNum } from "../../assets/utils";
import { setPassword, setUsername } from "../../redux/login/login.actions";
import {
  selectLoginPassword,
  selectLoginUsername,
} from "../../redux/login/login.selectors";

const LoginUsernameInputs = ({
  setUsername,
  setPassword,
  selectLoginPassword,
  selectLoginUsername,
}) => {
  const handle_input_change = (e) => {
    const name = e.currentTarget.name;
    const value = toPureNum(e.currentTarget.value);
    // debugger;

    const setTheState = `set${name}`;
    // debugger;
    const fff = eval(setTheState);
    fff(value);
  };

  return (
    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
      <input
        className="input--custom px-3 py-2"
        type="text"
        placeholder="نام کاربری"
        name="Username"
        value={toPersianNum(selectLoginUsername)}
        onChange={(e) => handle_input_change(e)}
      />
      <input
        className="input--custom px-3 py-2 mt-3 mt-sm-0"
        type="password"
        placeholder="رمز عبور"
        name="Password"
        value={toEnglishNum(selectLoginPassword)}
        onChange={(e) => handle_input_change(e)}
      />
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  selectLoginPassword: selectLoginPassword,
  selectLoginUsername: selectLoginUsername,
});

const mapDispatchToProps = (dispatch) => ({
  setUsername: (x) => dispatch(setUsername(x)),
  setPassword: (x) => dispatch(setPassword(x)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginUsernameInputs);
